<div class="d-md-flex">
    <div class="col-5 page-left-side d-none d-md-block">
      <img src="../../../../assets/images/{{tenantId}}/page-side-img.svg"  alt="Login Image" />
    </div>
    <div class="col-12 col-md-7  page-right-side">
      <div class="text-end col-11 mt-3 language-container">
        <select class="language-select" (change)="onLanguageChange($event)" [value]="languageService.currentLanguage">
          <option value="en">English</option>
          <option value="ar">العربية</option>
        </select>
      </div>  
  
      <div class=" col-12  p-4 form-content" >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
  
    </div>
  </div>